import React, { useEffect, useRef, useState } from 'react';
import datetime from '../../Datetime';
import { Root } from './styles';
import { cx } from '@linaria/core';
import { Label as TeaserLabel } from '../teaserPrimitiveStyles';
import { Typo } from '../../Typo';
const ONE_DAY_IN_MS = 86400000;
const FIFTEEN_MINUTES_IN_MS = 15 * 60 * 1000;
function getTimeRepresentation(date) {
    const now = new Date();
    const targetDate = new Date(date);
    const difference = targetDate.getTime() - now.getTime();
    if (difference <= 0) {
        return 'Seit';
    }
    if (difference <= FIFTEEN_MINUTES_IN_MS) {
        return 'Ab';
    }
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const tomorrow = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
    if (targetDate >= today && targetDate < tomorrow) {
        return 'Ab';
    }
    else if (targetDate >= tomorrow && targetDate < new Date(tomorrow.getTime() + ONE_DAY_IN_MS)) {
        return 'Morgen Ab';
    }
    const day = targetDate.getDate();
    const month = targetDate.getMonth() + 1;
    return `${day}.${month}. • `;
}
function AvailableSince({ date }) {
    /** Variables */
    const [isLive, setIsLive] = useState(() => new Date(date) < new Date());
    const timeoutRef = useRef(null);
    /** Construktor-Hook & Effect-Hooks */
    useEffect(() => {
        const timeLeft = new Date(date).getTime() - Date.now();
        if (!isLive && timeLeft <= ONE_DAY_IN_MS) {
            timeoutRef.current = setTimeout(() => {
                setIsLive(true);
            }, timeLeft);
        }
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, [date, isLive]);
    const timePrefix = getTimeRepresentation(date);
    const timeOfDay = datetime.getFormatTime(date);
    /** JSX */
    return (React.createElement("span", { className: cx(TeaserLabel.base, Root.base, Typo.base, Typo.info03, isLive && Root.isLive) },
        timePrefix,
        " ",
        timeOfDay,
        " Uhr"));
}
export default AvailableSince;
